export default (array, url, formatMessage) => {
  return array.map(([key, { text, link, ...rest }]) => ({
    ...rest,
    key,
    text: formatMessage ? formatMessage(text) : text,
    link: `${url}${link}`
  }))
};